var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coi)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.openInsuraceCertificates()}}},[_vm._v("Yes")]):_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.openInsuraceCertificates()}}},[_vm._v("No")])
}
var staticRenderFns = []

export { render, staticRenderFns }